// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--Eiss0","body":"body--38NV0"};